import {
  AVAILABLE_NATIONALITY_FLAG_DIMENSIONS,
  NATIONALITY_FLAG_MAP,
} from '$/(application)/travel-insurance/checkout/[carrierCode]/constants';

/**
 * Get the equivalent flag of the nationality for display
 * @param nationalityCode
 * @return string
 */
export const getNationalityFlagCodeRef = (
  nationalityCode: keyof typeof NATIONALITY_FLAG_MAP,
): string => {
  const flagCode =
    NATIONALITY_FLAG_MAP?.[
      nationalityCode.toUpperCase() as keyof typeof NATIONALITY_FLAG_MAP
    ];
  if (flagCode) return flagCode;
  return nationalityCode;
};
const FLAG_CDN_IMG_SRC = 'https://flagcdn.com/{dimension}/{flagCode}.png';
/**
 * Generates the URL for a nationality flag image based on the provided dimension and nationality code.
 *
 * @param dimension - The dimension of the flag image. For example, 'w20', 'h40', etc.
 *                    More information on available dimensions can be found at https://flagpedia.net/download/api.
 * @param nationalityCode - The code of the nationality for which the flag image is required.
 * @returns The URL of the flag image.
 */
export const getNationalityFlagImageSrc = (
  dimension: (typeof AVAILABLE_NATIONALITY_FLAG_DIMENSIONS)[number],
  nationalityCode?: string,
): string => {
  if (!nationalityCode) return '';

  const flagCode = getNationalityFlagCodeRef(
    nationalityCode as keyof typeof NATIONALITY_FLAG_MAP,
  );
  return FLAG_CDN_IMG_SRC.replace('{dimension}', dimension).replace(
    '{flagCode}',
    flagCode.toLowerCase(),
  );
};
